
webpack.register(
    'blocks/wgt-iframe/wgt-iframe',
    function() {
        return import('blocks/wgt-iframe/wgt-iframe');
    },
    true
);